module.exports = __webpack_public_path__ + "static/media/bookmark-svgrepo-com (4).c3878cdd.svg";